var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"showMoreItemsButton",staticClass:"link/focus",on:{"click":function($event){return _vm.showMoreItems($event)}}},[_c('p',{staticClass:"typography",domProps:{"innerHTML":_vm._s(_vm.showMoreItemsButtonHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }